<template>
  <div>
    <b-overlay :show="loading && false" opacity="0.99">
      <b-row>
        <b-col>
          <v-data-table
            :headers="headers"
            :items="items"
            dense
            :server-items-length="count"
            :options.sync="options"
            :footer-props="{
              'items-per-page-options': [10, 15, 20, 25, 50, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum resultado corresponde aos filtros"
            no-results-text="Nenhum resultado corresponde aos filtros"
            @update:options="getHistory"
          >
            <template v-slot:[`item.when`]="{ item }">
              {{ formatDate(item.when) }}
            </template>
            <template v-slot:[`item.entity_then`]="{ item }">
              <div v-if="item.entity_then">
                <div v-for="k in Object.keys(item.entity_then)" :key="k">
                  {{ `${item.fields[k]}: ${item.entity_then[k]}` }}
                </div>
              </div>
            </template>
            <template v-slot:[`item.entity_now`]="{ item }">
              <div v-if="item.entity_now">
                <div v-for="k in Object.keys(item.entity_now)" :key="k">
                  {{ `${item.fields[k]}: ${item.entity_now[k]}` }}
                </div>
              </div>
            </template>
          </v-data-table>
        </b-col>
      </b-row>
      <ErrorsMessages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import { formatDate } from "../../lib/format";

import api from "../../services/api";

export default {
  name: "HistoryLogs",

  components: {
    ErrorsMessages,
  },

  created() {},

  data() {
    return {
      errors: [],

      show: false,

      loading: false,

      headers: [
        { text: "Responsável", value: "user_name" },
        { text: "Ocorrência", value: "when" },
        { text: "Ação", value: "action", sortable: false },
        { text: "Informações", value: "entity_now", sortable: false },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["when"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,
    };
  },
  methods: {
    formatDate,

    async getHistory() {
      try {
        this.loading = true;

        let sortings = [];
        for (let i = 0; i < this.options.sortBy.length; i++) {
          let header = this.options.sortBy[i];
          let order = this.options.sortDesc[i] ? "desc" : "asc";
          sortings.push({ header, order });
        }

        sortings = JSON.stringify(sortings);

        let params = {
          page: this.options.page,
          items_per_page: this.options.itemsPerPage,
          sortings,
        };

        let response = await api.get("/rest-home/history/finance", { params });

        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>